import { environment } from '../environments/environment';

export const config = {
  apiBaseUrl: environment.apiBaseUrl,
  examApiBaseUrl: environment.examApiBaseUrl,
  traningAppUrl: environment.traningAppUrl,
  redirectURL: environment.redirectURL,
};
